import { render, staticRenderFns } from "./TextThresholdEdit.vue?vue&type=template&id=59721e49&scoped=true"
import script from "./TextThresholdEdit.vue?vue&type=script&lang=js"
export * from "./TextThresholdEdit.vue?vue&type=script&lang=js"
import style0 from "./TextThresholdEdit.vue?vue&type=style&index=0&id=59721e49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59721e49",
  null
  
)

export default component.exports